import Vue from 'vue'

export default Vue.directive('facebook-signin-button', {
  bind: function (el, binding, vnode) {
    CheckComponentMethods()
    let appId = binding.value
    let facebookSignInAPI = document.createElement('script')
    facebookSignInAPI.setAttribute('src', '//connect.facebook.net/en_US/sdk.js')
    document.head.appendChild(facebookSignInAPI)

    facebookSignInAPI.onload = InitFacebookButton

    function InitFacebookButton () {
      FB.init({
        appId: appId,
        cookie: true,  // enable cookies to allow the server to access the session
        xfbml: true,
        version: 'v7.0'
      })
      FB.getLoginStatus(function (response) {
        console.log(FB)
        if (response && response.status === 'connected') {
          console.log(response)
          // FB.logout(function (response) {
          //   // document.location.reload();
          //   console.log(response)
          // });
        }
      });
      OnInit();
      // FB.logout()
    }

    el.addEventListener('click', PopUp)

    function PopUp () {
      FB.login(function (facebookResponse) {
        if (facebookResponse.status === 'connected') {
          OnSuccess(facebookResponse)
        } else {
          Onfail()
        }
      }, { scope: 'email' })
    }
    function OnSuccess (token) {
      vnode.context.OnFacebookAuthSuccess(token)
    }
    function Onfail () {
      vnode.context.OnFacebookAuthFail('Facebook sign-in failed')
    }
    function OnInit () {
      vnode.context.OnFacebookInit()
    }
    function CheckComponentMethods () {
      if (!vnode.context.OnFacebookAuthSuccess) {
        throw new Error('The method OnFacebookAuthSuccess must be defined on the component')
      }

      if (!vnode.context.OnFacebookAuthFail) {
        throw new Error('The method OnFacebookAuthFail must be defined on the component')
      }
    }
  }
})


// WEBPACK FOOTER //
// ./src/utils/facebook.js